import { DotLegalAlert, DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

interface CancelPlanDialogProps {
    inProgress: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

// Cancelling an open mitigation plan abandons it (kept in history) and returns the risk to untreated.
// No reason is recorded, so this is a plain confirmation rather than a reason-capturing dialog.
function CancelPlanDialog({ inProgress, onClose, onSubmit }: CancelPlanDialogProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            open
            header={translateString("riskMitigationCancelPlanConfirmTitle")}
            buttonOkText={translateString("riskMitigationActionCancelPlan")}
            onDialogClose={onClose}
            onOkClick={onSubmit}
            inProgress={inProgress}
            size={"sm"}
        >
            <DotLegalAlert severity={"warning"} warningText={translateString("riskMitigationCancelPlanConfirmText")} />
        </DotLegalDialog>
    );
}

export default CancelPlanDialog;
